<template lang="pug">
.card.market-card
  .card-header.bg-more-head.collapse-more(
    :id="'heading-anb-' + id"
    data-toggle='collapse'
    :data-target="'#collapse-anb-' + id"
    :aria-controls="'collapse-anb-' + id"
    aria-expanded=true
  )
    .flex-grow-1.text-ellipsis.text-uppercase.mr-2 {{ $tc("m.BT_ANB", 1) }}
  .collapse.show(
    :aria-labelledby="'heading-anb-' + id"
    :id="'collapse-anb-' + id"
  )
    .card-body.p-0
      .market-card-content
        .two-column(v-if="mode == 0 || mode == 1")
          .two-column-title {{ $t("ui.full_time") }}
          .two-column-content
            .two-column-group
              .two-column-odd-area
                .two-column-odd-area-oddtype
                  p.mb-0 {{ $tc("m.BT_H", 1) }}
                .two-column-odd-area-group
                  template(v-if="moreItems['anbo'] && moreItems['anbo']['H'] && moreItems['anbo']['H'][6] && moreItems['anbo']['H'][5] != 0 && moreItems['anbo']['H'][5] != ''")
                    OddsItem(:odds="moreItems['anbo']['H']" idx=5 :typ="oddsType" dataType="3")
                  template(v-else)
                    OddsDisabled
            .two-column-group
              .two-column-odd-area
                .two-column-odd-area-oddtype
                  p.mb-0 {{ $tc("m.BT_D", 1) }}
                .two-column-odd-area-group
                  template(v-if="moreItems['anbo'] && moreItems['anbo']['D'] && moreItems['anbo']['D'][6] && moreItems['anbo']['D'][5] != 0 && moreItems['anbo']['D'][5] != ''")
                    OddsItem(:odds="moreItems['anbo']['D']" idx=5 :typ="oddsType" dataType="3")
                  template(v-else)
                    OddsDisabled
</template>

<script>
import OddsItem from "@/components/mobile/main/xitem/oddsItem";
import OddsDisabled from "@/components/mobile/main/xitem/oddsDisabled";
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";

export default {
  components: {
    OddsItem,
    OddsDisabled
  },
  mixins: [mixinHDPOUOdds],
  props: {
    mode: {
      type: Number
    }
  }
}
</script>